import { toTitleCase } from "@timeedit/registration-shared";
import { HeaderProps } from "react-big-calendar";

type CalendarHeaderProps = HeaderProps & { isDesktop: boolean };

export function CalendarHeader({
  isDesktop,
  localizer,
  date,
}: CalendarHeaderProps): React.JSX.Element {
  return (
    <div className="rbc-header">
      <span>{formatHeaders(date)}</span>
    </div>
  );

  function formatHeaders(date: Date): string {
    return toTitleCase(localizer.format(date, isDesktop ? "dddd" : "ddd"));
  }
}
